export default __webpack_public_path__ + "img/InterDisplay-ExtraLight_8501eb0.woff2";